import { useNavigate } from '@thd-olt-component-react/router';
import React, { useEffect, useState } from 'react';
import { ConnectBuildertrendAccount } from '../../../hooks/purchase-history-hooks';
import { IBtApiState } from '../../../models/purchase-history';
import { getBTLinkParams } from '../../../utils/buildertrend-utils';
import { getWindow } from '../../../utils/general';
import { BuildertrendModal } from './buildertrend-modal/BuildertrendModal';

const generateButtonText = (userIsLinked: boolean) => {
  if (userIsLinked) {
    return 'Disconnect Buildertrend';
  }
  return 'Connect Buildertrend';
};

export const BuildertrendButton = () => {
  // Admin unlink radio buttons state
  const [adminUnlinkRadio, setAdminUnlinkRadio] = useState<'customer' | 'user'>(
    'user',
  );
  const [open, setOpen] = useState(false);
  const [btApiState, setBtApiState] = useState<IBtApiState>({
    isLoading: false,
    btResponse: undefined,
  });

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    if (btApiState.btResponse !== undefined) {
      navigate();
      getWindow()?.location.reload();
    }
  };
  const handleOpen = () => setOpen(true);
  const btLinkStatusCheck =
    getWindow()?.THD_CUST_ACCOUNT_OM?.userState?.btLinkStatus || '';

  const paramsInfo: string = getWindow()?.location.search || '';
  const { code, state } = getBTLinkParams(paramsInfo);

  const userIsLinked = btLinkStatusCheck === 'ACTIVE';

  useEffect(() => {
    if (code && state === 'STATE') {
      // Checkes if redirected from buildertrend to continue connection process
      handleOpen();
      ConnectBuildertrendAccount(code, btApiState, setBtApiState);
    }
  }, []);

  const BuildertrendModalProps = {
    open,
    handleOpen,
    handleClose,
    userIsLinked,
    adminUnlinkRadio,
    setAdminUnlinkRadio,
    btApiState,
    setBtApiState,
  };

  return (
    <div className="sui-flex sui-items-center">
      <img
        src="https://assets.thdstatic.com/images/v1/BuildertrendIcon.svg"
        alt="Buildertrend Icon"
        width="20px"
        height="25px"
      />
      <button
        data-testid="buildertrend-button"
        type="button"
        className="sui-underline"
        onClick={() => {
          handleOpen();
        }}
      >
        {generateButtonText(userIsLinked)}
      </button>

      <BuildertrendModal {...BuildertrendModalProps} />
    </div>
  );
};
